import { generateAPI } from "../api.generator";

export const getSettlementHistory = generateAPI<
  any,
  {
    settlementDate: string;
	  settlementAmount: number;
  }[]
>("get", "aso-ebi/settlement-history");
